import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MasterConsultaFundosService } from './master-consulta-fundos.service';

import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, MatSortable, Sort } from '@angular/material/sort';

import { Funds } from './master-consulta-fundos.models';
import { MasterAssociarFundosComponent } from '../associar-fundos/master-associar-fundos.component';
import { CustomAuthenticationService } from '@app/auth/services/custom-authentication.service';
import { naturalSortData } from '../../../extensions/list.extensions';
import { MatPaginator } from '@angular/material/paginator';

/**
 * This Component manages the presentation logic of Edit screen
 *
 */
@Component({
  selector: 'app-master-consulta-fundos',
  templateUrl: './master-consulta-fundos.component.html',
  styleUrls: ['./master-consulta-fundos.scss'],
})
export class MasterConsultaFundosComponent implements OnInit {
  funds: any;
  displayedColumns: string[] = [
    'fundCode',
    'name',
    'totalGroups',
    'totalUsers',
    'actions',
  ];
  sorted: boolean = false;
  filterAutoComplete: Array<any>;
  fundsComplete: any;
  dialogConfig: any;
  editFund = 'Editar fundo';
  @ViewChild('sortFunds', { static: false }) sortFunds: MatSort;
  @ViewChild('paginator') paginator: MatPaginator;

  fundsFilter: any;
  constructor(
    private _masterFundsService: MasterConsultaFundosService,
    private dialog: MatDialog,
    router: Router,
    activeRoute: ActivatedRoute,
    private customAuthenticationService: CustomAuthenticationService,
  ) { }

  ngOnInit() {
    this.getFunds();

    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.disableClose = true;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.hasBackdrop = true;
    this.dialogConfig.height = '90vh';
    this.dialogConfig.width = '92vw';
    this.dialogConfig.maxWidth = '100vw';
  }

  async getFunds() {
    const  funds  = await this._masterFundsService.getFunds();

    this.funds = new MatTableDataSource<any>(
      [...funds].sort((a, b) => {
        if (a.fundCode && b.fundCode) {
          return a.fundCode
            .toLowerCase()
            .normalize('NFD')
            .replace(/[^a-zA-Z0-9s]/g, '') >
            b.fundCode
              .toLowerCase()
              .normalize('NFD')
              .replace(/[^a-zA-Z0-9s]/g, '')
            ? 1
            : -1;
        }
      }),
    );

    this.funds.sortingDataAccessor = (data, sortHeaderId) =>
      typeof data[sortHeaderId] === 'string'
        ? data[sortHeaderId]
          .normalize('NFD')
          .replace(/[^a-zA-Z0-9s]/g, '')
          .toLowerCase()
        : data[sortHeaderId];

    this.funds.sort = this.sortFunds;
    this.sortFunds.disableClear = true;
    this.funds.paginator = this.paginator;
    if (this.fundsFilter != null) {
      this.funds.filter = this.fundsFilter;
    }
  }

  filterFunds() {
    this.funds.filterPredicate = (data, filter) => {
      if (data.fundCode === null || data.fundCode === undefined) {
        data.fundCode = '';
      }
      if (data.name === null || data.name === undefined) {
        data.name = '';
      }
      return (
        data.fundCode.toLowerCase().includes(filter.toLowerCase()) ||
        data.name.toLowerCase().includes(filter.toLowerCase())
      );
    };
    this.fundsFilter = (event.target as HTMLInputElement).value;
    this.funds.filter = this.fundsFilter;

    if (this.fundsFilter.length > 0 && this.fundsFilter.length % 2 == 0) {
      this.fundsComplete = this.funds.filteredData;
    } else if (this.fundsFilter.length == 0) {
      this.fundsComplete = [];
    }
  }

  async openDialogAssociarFundos(code, name) {
    this.dialogConfig.data = {
      code,
      name,
    };
    const dialogINstance = this.dialog.open(
      MasterAssociarFundosComponent,
      this.dialogConfig,
    );
    await dialogINstance.beforeClosed().toPromise();
    await this.getFunds();
  }

  hasPermission(permissionName: string) {
    return this.customAuthenticationService.hasPermission(permissionName);
  }
}
